export const QUERY_LEADS_WITH_NAME = {
  type: "and",
  queries: [
    {
      type: "object_type",
      object_type: "lead",
    },
    {
      type: "or",
      queries: [
        {
          type: "field_condition",
          condition: {
            type: "exists",
          },
          field: {
            type: "regular_field",
            object_type: "lead",
            field_name: "name",
          },
        },
        {
          type: "has_related",
          this_object_type: "lead",
          related_object_type: "contact",
          related_query: {
            type: "and",
            queries: [
              {
                type: "field_condition",
                condition: {
                  type: "exists",
                },
                field: {
                  type: "regular_field",
                  object_type: "contact",
                  field_name: "name",
                },
              },
            ],
          },
        },
        {
          type: "field_condition",
          condition: {
            type: "number_range",
            gt: 0,
          },
          field: {
            type: "regular_field",
            object_type: "lead",
            field_name: "num_phone_numbers",
          },
        },
        {
          type: "field_condition",
          condition: {
            type: "number_range",
            gt: 0,
          },
          field: {
            type: "regular_field",
            object_type: "lead",
            field_name: "num_email_addresses",
          },
        },
      ],
    },
  ],
};

export const QUERY_LEADS_WITH_EMAILS = {
  type: "and",
  queries: [
    {
      type: "object_type",
      object_type: "lead",
    },
    {
      type: "field_condition",
      condition: {
        type: "number_range",
        gt: 0,
      },
      field: {
        type: "regular_field",
        object_type: "lead",
        field_name: "num_email_addresses",
      },
    },
  ],
};

export const QUERY_LEADS_WITH_PHONES = {
  type: "and",
  queries: [
    {
      type: "object_type",
      object_type: "lead",
    },
    {
      type: "field_condition",
      condition: {
        type: "number_range",
        gt: 0,
      },
      field: {
        type: "regular_field",
        object_type: "lead",
        field_name: "num_phone_numbers",
      },
    },
  ],
};

export const QUERY_LEADS_WITH_CONTACT_NAMES = {
  type: "and",
  queries: [
    {
      type: "object_type",
      object_type: "lead",
    },
    {
      type: "has_related",
      this_object_type: "lead",
      related_object_type: "contact",
      related_query: {
        type: "field_condition",
        field: {
          field_name: "name",
          object_type: "contact",
          type: "regular_field",
        },
        condition: {
          type: "exists",
        },
      },
    },
  ],
};

export const QUERY_LEADS_WITH_ADDRESS_1 = {
  type: "and",
  queries: [
    {
      type: "object_type",
      object_type: "lead",
    },
    {
      this_object_type: "lead",
      type: "has_related",
      related_object_type: "address",
      related_query: {
        type: "field_condition",
        field: {
          field_name: "location",
          object_type: "address",
          type: "regular_field",
        },
        condition: {
          type: "exists",
        },
      },
    },
  ],
};

export const QUERY_LEADS_WITH_URLS = {
  type: "and",
  queries: [
    {
      type: "object_type",
      object_type: "lead",
    },
    {
      type: "field_condition",
      field: {
        field_name: "url",
        object_type: "lead",
        type: "regular_field",
      },
      condition: {
        type: "exists",
      },
    },
  ],
};
